module.exports = __webpack_public_path__ + "static/media/BobbyJones-Condensed.682c0b35.woff2";